export default "__VITE_ASSET__CI9cTewV__"